<template>
    <div class="service-form">
        <div class="service-document" >

            <div class="form" >
                <div class="form-client">
                    <div class="separator bt-0">
                        {{ $t('dados-auditoria') }}
                    </div>
                    <div class="columns is-100 is-multiline is-mobile client-info is-gapless mb-0">
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('colaborador') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.usuario ? data.usuario.nome : '—' }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('datahora') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.datahora ? $moment(data.datahora).format('L') : '—' }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('origem') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.origem ? data.origem : '—' }} </span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer">
                                    <span class="description"> {{ $t('registro') + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span> {{ data.tabela ? data.tabela : '—' }} </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="separator dual-column">
                        <div class="before">
                            {{ $t('registros-anterior') }}
                        </div>
                        <div class="after">
                            {{ $t('registros-depois') }}
                        </div>
                    </div>

                    <div class="columns is-100 is-multiline is-mobile item-info is-gapless mb-0 client-info"
                        v-for="(fs, i) in data.itens"
                        :key="i"
                    >
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer capitalize">
                                    <span class="description"> {{ fs.campo + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span v-if="fs.valorant && fs.valorant.length < cutIn">{{ fs.valorant }}</span>
                                    <b-collapse :open="false" position="is-bottom" aria-id="valorant" v-else-if="fs.valorant && fs.valorant.length >= cutIn">
                                        <template #trigger="props">
                                            <span v-if="!props.open">{{ verifyText(fs.valorant) }}</span>
                                            <a aria-controls="valorant">
                                                {{ !props.open ? 'Mostrar' : 'Esconder' }}
                                            </a>
                                        </template>
                                        <p class="force-break">{{ fs.valorant }}</p>
                                    </b-collapse>
                                    <span v-else>—</span>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half info">
                            <div class="columns is-gapless mb-0">
                                <div class="column is-narrow with-spacer capitalize">
                                    <span class="description"> {{ fs.campo + ': ' }} </span>
                                </div>
                                <div class="column">
                                    <span v-if="fs.valoratual && fs.valoratual.length < cutIn">{{ fs.valoratual ? fs.valoratual : '—' }}</span>
                                    <b-collapse :open="false" position="is-bottom" aria-id="valoratual" v-else-if="fs.valoratual && fs.valoratual.length >= cutIn">
                                        <template #trigger="props">
                                            <span v-if="!props.open">{{ verifyText(fs.valoratual) }}</span>
                                            <a aria-controls="valoratual">
                                                {{ !props.open ? $t('mostrar') : $t('esconder') }}
                                            </a>
                                        </template>
                                        <p class="force-break">{{ fs.valoratual }}</p>
                                    </b-collapse>
                                    <span v-else>—</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
import AuditoriaService from '@/services/AuditoriaService';
import { palette as paleta } from "@/functions/color/Palette";

export default {
    data() {
        return {
            data: { },
            primary_color: this.$store.state.partnerSystemHasLayout.primary_color,
            secondary_color: paleta.getChartColors()[paleta.getChartColors().length-1],
            tertiaryColor: paleta.getChartColors()[3],
            cutIn: 40
        };
    },
    props: {
        idauditoria: 0
    },
    created () {
        this.service = new AuditoriaService(this.$http, this.$router);
        this.loadData(this.idauditoria);
    },
    methods: {
        showHideStr(srt){

        },
        verifyText(str){
            if(str.length>this.cutIn) str = str.substring(0,this.cutIn)+'...';
            return str;
        },
        loadData( idauditoria ){
            this.$store.commit('addLoader');
            this.service.findById( idauditoria ).then( res =>{
                this.data = res.content;
            })
            .catch(e => {
                this.$root.showMessage('error', 'msg-erro-relatorio');
            })
            .finally(_ => {
                this.$store.commit('removeLoader');
            });
        },
    },
};

</script>
<style lang="scss" scoped>

.with-spacer{
    margin-right: 0.5rem !important;
}
.service-form{
    .force-break{
        white-space: pre-wrap;
        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: break-word;
    }
    .bt-0{
        border-top: 0 !important;
    }

    .service-document{
        background: $sovis-white;
        height: 100%;
        padding: 10px 20px;

        .enterprise-logo, .client-logo {
            .logo{
                height: auto;
                max-height: 80px;
            }
        }
        .enterprise-info {
            h2{
                text-align: center;
                font-size: 18px;
                font-weight: 600;
            }
            h3{
                text-align: center;
                font-size: 12px;
            }
        }
        .report-title {
            font-size: 20px;
            margin-bottom: 10px;

            h1{
                font-weight: 600;
            }
        }

        .form{
            width: 100%;

            .form-client{
                width: 100%;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                margin-bottom: 20px;

                .separator{
                    width: 100%;
                    border-top: 1px solid $table-border;
                    border-bottom: 1px solid $table-border;
                    padding: 10px 0;
                    text-align: center;
                    margin-bottom: 10px;
                    font-weight: 600;
                    font-size: 18px;
                }

                .separator.dual-column{
                    display: flex;
                    justify-content: space-between;

                    .after, .before{
                        width: 50%;
                    }
                }

                .client-info{
                    .description{
                        font-weight: 600;
                        // font-size: 16px;
                        margin-bottom: 0px;
                    }
                    .capitalize{
                        text-transform: capitalize;
                    }
                    .info{
                        margin-bottom: 0.5rem;
                    }
                }

                .data-block-alt{
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;

                    .client-info{
                        width: 20%;
                    }
                }

                .data-block-form{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;

                    .client-info{
                        width: 100%;
                        display: flex;
                        justify-content: flex-start;

                        h4, p{
                            width: 20%;
                        }
                    }
                }

                .img-wrapper{

                    padding: 10px;
                    height: max-content;

                    img{
                        width: 100%;
                        height: 200px;
                        object-fit: contain;
                    }

                    .legend, .opt-obs{
                        font-size: 12px;
                        display: flex;
                        justify-content: space-between;
                        margin-top: 5px;

                        p{
                            width: 100%;
                            text-align: center;
                            text-transform: uppercase;
                        }
                        .icon-location{
                            width: 25%;
                            text-align: right;
                            .svg-icons{
                                width: 30px;
                                height: 30px;
                            }
                        }

                        .opt-text {
                            display: flex;
                            flex-wrap: wrap;

                            p{
                                width: 100%;
                            }
                        }


                    }

                    &.share, &.pesquisa{
                        .client-info{
                            h4, p{
                                width: 10%;
                                &.bigger{
                                    width: 60%;
                                }
                            }
                        }
                    }
                }

                .map-photo{
                    text-align: center;
                    width: 100%;
                    margin-top: 10px;

                    img{
                        border: 1px solid $table-border;
                        max-width: 100%;
                    }

                    .map-legend{
                        display: flex;

                        .map-legend-container {

                            .legend-item{
                                text-align: left;
                                margin-left: 30px;
                                margin-right: 30px;
                            }
                        }
                    }
                }
            }

            .assinatura{
                margin-top: 80px;
                margin-right: 20px;
                width: 300px;
                height: 300px;

                .opt-img {
                    border-bottom: 1px solid $table-border;
                    width: 300px;
                    height: 250px;

                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                .opt-legend, .opt-obs{
                    font-size: 12px;
                    display: flex;
                    justify-content: space-between;
                    margin-top: 5px;

                    p{
                        width: 100%;
                    }
                }
            }
        }
    }
}

</style>